'use strict';

_([
  ['map', 'collect'],
  ['reduce', 'inject', 'foldl'],
  ['reduceRight', 'foldr'],
  ['find', 'detect'],
  ['select'/*, 'filter'*/], // leave 'filter' with angular implementation
  ['where'],
  ['findWhere'],
  ['reject'],
  ['invoke'],
  ['pluck'],
  ['max'],
  ['min'],
  ['sortBy'],
  ['groupBy'],
  ['countBy'],
  ['shuffle'],
  ['toArray'],
  ['size'],
  ['first', 'head', 'take'],
  ['initial'],
  ['last'],
  ['rest', 'tail', 'drop'],
  ['compact'],
  ['flatten'],
  ['without'],
  ['union'],
  ['intersection'],
  ['difference'],
  ['uniq', 'unique'],
  ['zip'],
  ['object'],
  ['indexOf'],
  ['lastIndexOf'],
  ['sortedIndex'],
  ['keys'],
  ['values'],
  ['pairs'],
  ['invert'],
  ['functions', 'methods'],
  ['pick'],
  ['omit'],
  ['parseInt'],
  ['escape'],
  ['unescape'],
  ['result'],
  ['template'],
  ['capitalize']
]).each(function (filters) {
  var factory = function () {
    return _.bind(_[filters[0]], _);
  };
  _(filters).each(function (filter) {
    app.filter(filter, factory);
  }).value();
}).value();

app.run(function ($window, $rootScope) {
  $rootScope._ = $window._;
});
